import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Maps, ImageExport, MapsComponent, MapsModule } from '@syncfusion/ej2-angular-maps';
import { italyMap } from '../../../../../../shared/italy-regions';
import { DataService } from '../../../../../../services/dashboard/data.service';
import { DmtUtilityService } from '../../../../../../services/dashboard/dmt-utility.service';
import { NtPotentialRegionInterface } from '../../../../../../shared/interfaces/nt-potential-region.interface';
import PptxGenJS from 'pptxgenjs';
import { NtMedicineInterface } from '../../../../../../shared/interfaces/nt-medicine.interface';
import { CommonModule } from '@angular/common';
import { NtOpenToAccessMapInterface } from '../../../../../../shared/interfaces/nt-openToAccess-map-interface';
import { NtChartRegionInterface } from '../../../../../../shared/interfaces/nt-chart-region.interface';

Maps.Inject(ImageExport);

@Component({
  selector: 'app-generate-national-report',
  imports: [MapsModule, CommonModule],
  templateUrl: './generate-national-report.component.html',
  styleUrl: './generate-national-report.component.css'
})
export class GenerateNationalReportComponent {

  @Input() medicineInfoData: NtMedicineInterface = {
    id: 0,
    businessName: '',
    creationDate: '',
    activeSubstance: '',
    therapeuticArea: '',
    therapeuticIndication: '',
    reimbursementClass: '',
    supplyClass: '',
    atc: '',
    aic: '',
    openToAccessType: '',
    medicineBrandInfo: {
      font: { title: '', subtitle: '' },
      colors: { title: '', subtitle: '', background: '' },
      logo: { url: '', altText: 'Logo' },
    },
    launched: false
  };
  @Output() isModalOpen = new EventEmitter<boolean>();

  @ViewChild('experienceMap') experienceMap!: MapsComponent;
  @ViewChild('regAccessMap') regAccessMap!: MapsComponent;
  @ViewChild('heatmap') heatmap!: MapsComponent;

  experienceMapBase64String: any = ''
  regAccessMapBase64String: any = ''
  heatmapBase64String: any = ''
  processMessage: string = ''

  public regionName: string | null | undefined;
  public medicineName: string = '';
  public medicineId = 1;

  public countryId = 1;

  public regionId = 1;

  public companyId = 1;

  public layersExpMap?: object[];
  public layersRegAccessMap?: object[];
  public layersHeatmap?: object[];

  today: Date = new Date();

  constructor (private us: DmtUtilityService, private dataService: DataService) { }

  medicineInfoHeader = [
    { text: 'PRINCIPIO\nATTIVO', options: { bold: true, fill: 'FFFFFF' } },
    { text: 'CLASSE DI\nRIMBORSABILITÀ', options: { bold: true, fill: 'FFFFFF' } },
    { text: 'AREA\nTERAPEUTICA', options: { bold: true, fill: 'FFFFFF' } },
    { text: 'CLASSE DI\nFORNITURA', options: { bold: true, fill: 'FFFFFF' } },
    { text: 'ATC', options: { bold: true, fill: 'FFFFFF' } },
    { text: 'AIC', options: { bold: true, fill: 'FFFFFF' } },
  ];

  medicineTherapeuticInfoHeader = [
    { text: 'INDICAZIONE TERAPEUTICA', options: { bold: true, fill: 'FFFFFF' } },
  ];

  medicineTableData: any[] = [];
  medicineTherapeuticInfoTableData: any[] = [];

  activitiesAndTacticsHeader = [
    { text: 'ATTIVITÀ', options: { bold: true, fill: 'FFFFFF', align: 'left', fontSize: 9 } },
    { text: '#', options: { bold: true, fill: 'FFFFFF', align: 'center', fontSize: 9 } },
    { text: 'COMPLETAMENTO %', options: { bold: true, fill: 'FFFFFF', align: 'center', fontSize: 9 } },
  ];


  openToAccessAndMarketHeader = [
    { text: 'DATA', options: { bold: true, fill: 'FFFFFF', align: 'left', fontSize: 9 } },
    { text: 'FORECAST', options: { bold: true, fill: 'FFFFFF', align: 'center', fontSize: 9 } },
    { text: 'ACTUAL', options: { bold: true, fill: 'FFFFFF', align: 'center', fontSize: 9 } }
  ];

  monitorinForecastvsActualHeader = [
    { text: 'REGIONE', options: { bold: true, fill: 'FFFFFF', align: 'left', fontSize: 9 } },
    { text: 'MESI FORECAST', options: { bold: true, fill: 'FFFFFF', align: 'center', fontSize: 9 } },
    { text: 'MESI ACTUAL', options: { bold: true, fill: 'FFFFFF', align: 'center', fontSize: 9 } },
    { text: 'Δ', options: { bold: true, fill: 'FFFFFF', align: 'center', fontSize: 9 } },
  ];

  regionalAccessHeader = [
    { text: 'REGIONE', options: { bold: true, fill: 'FFFFFF', align: 'left', fontSize: 9 } },
    { text: 'DATA FORECAST', options: { bold: true, fill: 'FFFFFF', align: 'center', fontSize: 9 } },
    { text: 'DOVE SIAMO', options: { bold: true, fill: 'FFFFFF', align: 'center', fontSize: 9 } }
  ];

  openToAccessTableRows: any[] = [];
  openToAccessTableData: any[] = [];

  openToMarketTableRows: any[] = [];
  openToMarketTableData: any[] = [];

  activitiesAndTacticsData: any[] = [];
  activitesAndTacticsTableData: any[] = [];
  leftActivitiesAndTacticsTableRows: any[] = [];
  rightActivitiesAndTacticsTableRows: any[] = [];

  regionalAccessEvolutionData: any[] = [];
  regionalAccessEvolutionTableData: any[] = [];

  experienceMapData: NtPotentialRegionInterface[] = [];
  experienceMapTableData: any[] = [];
  leftExpMapTableRows: any[] = [];
  rightExpMapTableRows: any[] = [];

  regionalAccessMapData: NtOpenToAccessMapInterface[] = [];

  heatmapData: NtPotentialRegionInterface[] = [];
  heatmapTableData: any[] = [];
  leftHeatmapTableRows: any[] = [];
  rightHeatmapTableRows: any[] = [];

  monitoringForecastvsActualData: any[] = [];
  monitoringForecastvsActualTableData: any[] = [];
  leftMonitoringForecastvsActualTableRows: any[] = [];
  rightMonitoringForecastvsActualTableRows: any[] = [];

  regionalAccessData: any[] = [];
  regionalAccessTableData: any[] = [];
  leftRegionalAccessTableRows: any[] = [];
  rightRegionalAccessTableRows: any[] = [];

  // Default brand info in case of missing data
  DEFAULT_MEDICINE_BRAND = {
    font: { title: 'Arial, sans-serif', subtitle: 'Helvetica, sans-serif' },
    colors: { title: '#141F58', subtitle: '#00CEBC', background: '#FFFFFF' },
    logo: { url: '', altText: 'Logo' },
  };

  brandInfoMedicine = this.DEFAULT_MEDICINE_BRAND;

  monthNamesIt = ['Gen', 'Feb', 'Mar', 'Apr', 'Mag', 'Giu', 'Lug', 'Ago', 'Set', 'Ott', 'Nov', 'Dic'];

  public openToAccessChartData: NtChartRegionInterface = {
    labels: [],
    actual: [],
    real: [],
    target: []
  };

  public openToMarketChartData: NtChartRegionInterface = {
    labels: [],
    actual: [],
    real: [],
    target: []
  };

  openToAccessLabels: string[] = [];
  openToAccessTargetData: (number | null)[] = [];
  openToAccessActualData: (number | null)[] = [];

  openToMarketLabels: string[] = [];
  openToMarketTargetData: (number | null)[] = [];
  openToMarketActualData: (number | null)[] = [];

  ngOnInit (): void {
    this.getSessionVariables()
    this.dataService.getRegioniData(this.medicineId, this.countryId).subscribe((data: NtPotentialRegionInterface[]) => {
      this.experienceMapData = data;
    });
    this.dataService.getHeatmapRegionalAccessData(this.medicineId, this.countryId).subscribe({
      next: (data: NtOpenToAccessMapInterface[]) => {
        this.regionalAccessMapData = data;
      },
      error: (error) => {
        console.error('Errore nel recupero dei dati della mappa regionale:', error);
      }
    });
    this.dataService.getRegioniHeatmapData(this.medicineId, this.countryId).subscribe((data: NtPotentialRegionInterface[]) => {
      this.heatmapData = data;
    });
    this.dataService.getRegionalActivityListStatsByMedicine(this.medicineId, this.countryId)
      .subscribe((data) => {
        this.activitiesAndTacticsData = data;
      });

    this.dataService.getRegionalAccessEvolutionData(this.companyId, this.medicineId, this.countryId).subscribe(data => {
      this.regionalAccessEvolutionData = data;
    });

    this.dataService.getNationalChart(this.medicineId, this.countryId).subscribe(data => {

      this.openToAccessChartData = data

      if (this.openToAccessChartData) {

        this.openToAccessLabels = this.openToAccessChartData.labels.map(dp => this.formatDatePointToIt(dp));

        this.openToAccessTargetData = this.buildCumulativeSeries(this.openToAccessChartData.labels, this.openToAccessChartData.target);

        this.openToAccessActualData = this.buildCumulativeSeries(this.openToAccessChartData.labels, this.openToAccessChartData.actual);

      }
    });

    this.dataService.getNationalMarketChart(this.medicineId, this.countryId).subscribe(data => {

      this.openToMarketChartData = data

      if (this.openToMarketChartData) {

        this.openToMarketLabels = this.openToMarketChartData.labels.map(dp => this.formatDatePointToIt(dp));

        this.openToMarketTargetData = this.buildCumulativeSeries(this.openToMarketChartData.labels, this.openToMarketChartData.target);

        this.openToMarketActualData = this.buildCumulativeSeries(this.openToMarketChartData.labels, this.openToMarketChartData.actual);

      }
    });

    this.dataService.getRegionalAccessMonitoringData(this.companyId, this.medicineId, this.countryId).subscribe(data => {
      this.monitoringForecastvsActualData = data;
      this.monitoringForecastvsActualData.sort((a, b) => a.regionName.localeCompare(b.regionName))
    });

    this.dataService.regionalAccessInfo(this.medicineId, this.countryId).subscribe(data => {
      this.regionalAccessData = data;
      this.regionalAccessData.sort((a, b) => a.regionName.localeCompare(b.regionName));
    });

    this.openModal();
    this.brandInfoMedicine = JSON.parse(sessionStorage.getItem('brandMedicine') ?? 'null') ?? this.DEFAULT_MEDICINE_BRAND;
  }

  getSessionVariables () {
    this.regionName = localStorage.getItem('regionName');
    this.medicineId = this.us.getSessionVariableNumber('medicineId', 0);
    this.countryId = this.us.getSessionVariableNumber('countryId');
    this.regionId = this.us.getSessionVariableNumber('regionId');
    this.medicineName = sessionStorage.getItem('businessName') || '';
    this.companyId = this.us.getSessionVariableNumber('companyId', 0);
  }

  openModal (): void {

    this.processMessage = 'Elaborazione dei dati...';


    (async () => {
      try {
        this.processMessage = 'Caricamento dei dati della mappa Esperienze per Regione...';
        await this.loadExperienceMap();

        this.processMessage = 'Caricamento dei dati della mappa Heatmap Accesso Regionale...';
        await this.loadRegAccessMap();

        this.processMessage = 'Caricamento dei dati della mappa Heatmap Apertura Ospedaliera...';
        await this.loadHeatmap();

        this.processMessage = 'Generazione di tabelle...';
        await this.generateTables();

        this.processMessage = 'Esportazione della presentazione...';
        await this.generatePPT();

        this.processMessage = 'Presentazione generata con successo!';
      } catch (error) {
        console.error('Error during PowerPoint generation:', error);
        this.processMessage = 'An error occurred. Please try again.';
      }
    })();

  }

  async generateTables (): Promise<void> {

    //Medicine Info table
    const med: NtMedicineInterface = this.medicineInfoData ?? {};

    const medicineTableRows = [
      [
        { text: med.activeSubstance ?? '-', options: { fontSize: 10, fontFace: this.brandInfoMedicine.font.title, color: "000000" } },
        { text: med.reimbursementClass ?? '-', options: { fontSize: 10, fontFace: this.brandInfoMedicine.font.title, color: "000000" } },
        { text: med.therapeuticArea ?? '-', options: { fontSize: 10, fontFace: this.brandInfoMedicine.font.title, color: "000000" } },
        { text: med.supplyClass ?? '-', options: { fontSize: 10, fontFace: this.brandInfoMedicine.font.title, color: "000000" } },
        { text: med.atc ?? '-', options: { fontSize: 10, fontFace: this.brandInfoMedicine.font.title, color: "000000" } },
        { text: med.aic ?? '-', options: { fontSize: 10, fontFace: this.brandInfoMedicine.font.title, color: "000000" } }
      ],
    ];

    const medicineTherapeuticInfoRows = [
      [
        { text: med.therapeuticIndication ?? '-', options: { fontSize: 10, fontFace: this.brandInfoMedicine.font.title, color: "000000" } },
      ],
    ];

    this.medicineTableData = [this.medicineInfoHeader, ...medicineTableRows];

    this.medicineTherapeuticInfoTableData = [this.medicineTherapeuticInfoHeader, ...medicineTherapeuticInfoRows];

    //Experience Map Table
    this.experienceMapTableData = this.experienceMapData.map(item => ([
      { text: item.regionName ?? '-', options: { fontSize: 10, fontFace: this.brandInfoMedicine.font.title, color: "000000" } },
      { text: item.percentage ? `${item.percentage}%` : '-', options: { fontSize: 10, fontFace: this.brandInfoMedicine.font.title, color: "000000" } },
    ]));

    const half = Math.ceil(this.experienceMapTableData.length / 2);

    this.leftExpMapTableRows = this.experienceMapTableData.slice(0, half);
    this.rightExpMapTableRows = this.experienceMapTableData.slice(half);

    //Heatmap Table
    this.heatmapTableData = this.heatmapData.map(item => ([
      { text: item.regionName ?? '-', options: { fontSize: 10, fontFace: this.brandInfoMedicine.font.title, color: "000000" } },
      { text: item.percentage ? `${item.percentage}%` : '-', options: { fontSize: 10, fontFace: this.brandInfoMedicine.font.title, color: "000000" } },
    ]));
    const halfHeatmap = Math.ceil(this.heatmapTableData.length / 2);
    this.leftHeatmapTableRows = this.heatmapTableData.slice(0, halfHeatmap);
    this.rightHeatmapTableRows = this.heatmapTableData.slice(halfHeatmap);

    //Activities and Tactics Table
    this.activitesAndTacticsTableData = this.activitiesAndTacticsData.map(item => {
      const totalCountry = item.totalCountry ?? 0;
      const totalCompleted = item.totalCompleted ?? 0;

      // calculate percentage
      const percentage =
        totalCountry > 0
          ? Number(((totalCompleted / totalCountry) * 100).toFixed(2))
          : 0;

      return [
        {
          text: item.name ?? '-',
          options: { fontSize: 8, fontFace: this.brandInfoMedicine.font.title, color: '000000', align: 'left' }
        },
        {
          text: totalCountry ? `${totalCountry}` : '-',
          options: { fontSize: 8, fontFace: this.brandInfoMedicine.font.title, color: '000000', align: 'center' }
        },
        {
          text: totalCountry > 0 ? `${percentage}%` : '-',
          options: { fontSize: 8, fontFace: this.brandInfoMedicine.font.title, color: '000000', align: 'center' }
        }
      ];
    });

    const halfActivitiesAndTactics = Math.ceil(this.activitesAndTacticsTableData.length / 2);
    const leftRows = this.activitesAndTacticsTableData.slice(0, halfActivitiesAndTactics);
    const rightRows = this.activitesAndTacticsTableData.slice(halfActivitiesAndTactics);

    this.leftActivitiesAndTacticsTableRows = [
      this.activitiesAndTacticsHeader,
      ...leftRows
    ];

    this.rightActivitiesAndTacticsTableRows = [
      this.activitiesAndTacticsHeader,
      ...rightRows
    ];

    //Evolution Regional Access Table
    const sorted = [...this.regionalAccessEvolutionData].sort((a, b) =>
      a.datePoint.localeCompare(b.datePoint)
    );

    const headerRow = sorted.map(item => {
      /*const [year, month] = item.datePoint.split('-');
      const monthIdx = Number(month) - 1;
      const label = `${this.monthNamesIt[monthIdx]}-${year.slice(-2)}`;*/

      const label = this.formatDatePointToIt(item.datePoint ?? '');

      return {
        text: label,
        options: {
          bold: true,
          align: 'center',
          fontFace: this.brandInfoMedicine.font.title,
          fontSize: 10,
          color: '00453B',
          fill: 'FFFFFF'
        }
      };
    });

    const regionsRow = sorted.map(item => ({
      text: item.forecast.join('\n'),
      options: {
        align: 'left',
        fontFace: this.brandInfoMedicine.font.title,
        fontSize: 8,
        color: '000000'
      }
    }));

    this.regionalAccessEvolutionTableData = [headerRow, regionsRow];

    //Open to Access Table
    this.openToAccessTableRows = this.openToAccessChartData.labels.map((labelMonth, idx) => {
      const [year, month] = labelMonth.split('-');   // "2024-09" -> ["2024","09"]
      const dateText = `${month}/${year}`;           // "09/2024"

      const forecastVal = this.openToAccessTargetData[idx];
      const forecastText =
        forecastVal != null ? `${forecastVal.toFixed(0)}%` : '-';

      // show actual only if we have a real point for that month
      const hasActualPoint = this.openToAccessChartData.actual.some(a => a.month === labelMonth);
      const actualVal = this.openToAccessActualData[idx];
      const actualText =
        hasActualPoint && actualVal != null ? `${actualVal.toFixed(0)}%` : '-';

      return [
        {
          text: dateText,
          options: {
            align: 'left',
            fontSize: 9,
            fontFace: this.brandInfoMedicine.font.title,
            color: '000000'
          }
        },
        {
          text: forecastText,
          options: {
            align: 'center',
            fontSize: 9,
            fontFace: this.brandInfoMedicine.font.title,
            color: '000000'
          }
        },
        {
          text: actualText,
          options: {
            align: 'center',
            fontSize: 8,
            fontFace: this.brandInfoMedicine.font.title,
            color: '000000'
          }
        }
      ];
    });

    this.openToAccessTableData = [
      this.openToAccessAndMarketHeader,
      ...this.openToAccessTableRows
    ];

    //Open to Market Table
    this.openToMarketTableRows = this.openToMarketChartData.labels.map((labelMonth, idx) => {
      const [year, month] = labelMonth.split('-');   // "2024-09" -> ["2024","09"]
      const dateText = `${month}/${year}`;           // "09/2024"

      const forecastVal = this.openToMarketTargetData[idx];
      const forecastText =
        forecastVal != null ? `${forecastVal.toFixed(0)}%` : '-';

      // show actual only if we have a real point for that month
      const hasActualPoint = this.openToMarketChartData.actual.some(a => a.month === labelMonth);
      const actualVal = this.openToMarketActualData[idx];
      const actualText =
        hasActualPoint && actualVal != null ? `${actualVal.toFixed(0)}%` : '-';

      return [
        {
          text: dateText,
          options: {
            align: 'left',
            fontSize: 9,
            fontFace: this.brandInfoMedicine.font.title,
            color: '000000'
          }
        },
        {
          text: forecastText,
          options: {
            align: 'center',
            fontSize: 9,
            fontFace: this.brandInfoMedicine.font.title,
            color: '000000'
          }
        },
        {
          text: actualText,
          options: {
            align: 'center',
            fontSize: 8,
            fontFace: this.brandInfoMedicine.font.title,
            color: '000000'
          }
        }
      ];
    });

    this.openToMarketTableData = [
      this.openToAccessAndMarketHeader,
      ...this.openToMarketTableRows
    ];


    //Monitoring Forecast vs Actual
    this.monitoringForecastvsActualTableData = this.monitoringForecastvsActualData.map(item => {
      // Conditional background for Δ column
      let deltaFill = 'FFFFFF'; // default white

      if (item.delta < 0) {
        deltaFill = 'CCF7DD'; // light green
      } else if (item.delta > 0) {
        deltaFill = 'FDE0E0'; // light red
      }

      return [
        {
          text: item.regionName ?? '-',
          options: {
            align: 'left',
            fontSize: 9,
            fontFace: this.brandInfoMedicine.font.title
          },
          color: '000000'
        },
        {
          text: item.forecast.toString(),
          options: {
            align: 'center',
            fontSize: 9,
            fontFace: this.brandInfoMedicine.font.title
          },
          color: '000000'
        },
        {
          text: item.actual.toString(),
          options: {
            align: 'center',
            fontSize: 9,
            fontFace: this.brandInfoMedicine.font.title
          },
          color: '000000'
        },
        {
          text: item.delta.toString(),
          options: {
            align: 'center',
            fontSize: 9,
            fontFace: this.brandInfoMedicine.font.title,
            fill: deltaFill // <--- conditional background color
          },
          color: '000000'
        }
      ];
    });

    const halfMonitoringForecastvsActual = Math.ceil(this.monitoringForecastvsActualTableData.length / 2);
    const leftMFARows = this.monitoringForecastvsActualTableData.slice(0, halfMonitoringForecastvsActual);
    const rightMFARows = this.monitoringForecastvsActualTableData.slice(halfMonitoringForecastvsActual);

    this.leftMonitoringForecastvsActualTableRows = [
      this.monitorinForecastvsActualHeader,
      ...leftMFARows
    ];

    this.rightMonitoringForecastvsActualTableRows = [
      this.monitorinForecastvsActualHeader,
      ...rightMFARows
    ];

    //Regional Access Widget
    /*this.regionalAccessTableData = this.regionalAccessData.map(item => {
      // Conditional background for Δ column
      let deltaFill = 'FFFFFF'; // default white

      if (this.compareDates(item.dueDate) < 0) {
        deltaFill = 'CCF7DD'; // light green
      } else if (this.compareDates(item.dueDate) > 0) {
        deltaFill = 'FDE0E0'; // light red
      }

      return [
        {
          text: item.regionName ?? '-',
          options: {
            align: 'left',
            fontSize: 9,
            fontFace: this.brandInfoMedicine.font.title
          },
          color: '000000'
        },
        {
          text: this.formatDate(item.dueDate.toString()),
          options: {
            align: 'center',
            fontSize: 9,
            fontFace: this.brandInfoMedicine.font.title
          },
          color: '000000'
        },
        {
          text: this.compareDates(item.dueDate) + " GIORNI",
          options: {
            align: 'center',
            fontSize: 9,
            fontFace: this.brandInfoMedicine.font.title,
            fill: deltaFill // <--- conditional background color
          },
          color: '000000'
        }
      ];
    });*/

    this.regionalAccessTableData = this.regionalAccessData.map(item => {
      const dueDate = item.dueDate ?? null;
      const endDate = item.endDate ?? null;

      // Column 2: show dueDate (or '-')
      const dueDateText = dueDate ? this.formatDate(dueDate.toString()) : '-';

      // Column 3: delta logic
      let deltaFill = 'FFFFFF';
      let deltaText = '-';

      if (endDate) {
        // Completed: show endDate, always green background
        deltaFill = 'FFFFFF';
        deltaText = `Accesso in data ${this.formatDate(endDate.toString())}`;
      } else if (dueDate) {
        // Not completed: show days delta
        const deltaDays = this.compareDates(dueDate);
        deltaText = `${deltaDays} GIORNI`;

        if (deltaDays < 0) {
          deltaFill = 'CCF7DD'; // green
        } else if (deltaDays > 0) {
          deltaFill = 'FDE0E0'; // red
        } else {
          deltaFill = 'FFFFFF'; // neutral
        }
      }

      return [
        {
          text: item.regionName ?? '-',
          options: { align: 'left', fontSize: 9, fontFace: this.brandInfoMedicine.font.title },
          color: '000000'
        },
        {
          text: dueDateText,
          options: { align: 'center', fontSize: 9, fontFace: this.brandInfoMedicine.font.title },
          color: '000000'
        },
        {
          text: deltaText,
          options: {
            align: 'center',
            fontSize: 9,
            fontFace: this.brandInfoMedicine.font.title,
            fill: deltaFill
          },
          color: '000000'
        }
      ];
    });

    const halfRegionalAccess = Math.ceil(this.regionalAccessData.length / 2);
    const leftRegionalAccessRows = this.regionalAccessTableData.slice(0, halfRegionalAccess);
    const rightRegionalAccessRows = this.regionalAccessTableData.slice(halfRegionalAccess);

    this.leftRegionalAccessTableRows = [
      this.regionalAccessHeader,
      ...leftRegionalAccessRows
    ];

    this.rightRegionalAccessTableRows = [
      this.regionalAccessHeader,
      ...rightRegionalAccessRows
    ];


    await new Promise((resolve) => setTimeout(resolve, 1000));
  }

  //Generate PPT
  async generatePPT (): Promise<void> {
    const pptx = new PptxGenJS();

    const slide1 = pptx.addSlide();
    //slide1.background = { path: 'assets/ppt/ppt-bg-slide-1.png' };

    //Logo medicine
    slide1.addImage({
      path: this.brandInfoMedicine.logo.url,
      x: 0.5,
      y: 0.4,
      w: '8%',
      h: '10%'
    });

    //company logo
    /*slide1.addImage({
      path: this.brandInfoMedicine.logo.url,
      x: 8.7,
      y: 0.4,
      w: '8%',
      h: '10%'
    });*/

    /*slide1.addImage({
      path: this.brandInfoMedicine.logo.url,
      x: 4.2,
      y: 0.7,
      w: '13%',
      h: '10%'
    });*/

    slide1.addText('Nazione', {
      x: 1.2,
      y: 1.9,
      h: '10%',
      fontSize: 20,
      fontFace: this.brandInfoMedicine.font.subtitle, //fontFace: 'Plus Jakarta Sans',
      color: this.brandInfoMedicine.colors.subtitle, //color:'000000',
      bold: true,
      align: 'center',
    });

    // Add the title (Farmaco 2)
    slide1.addText(this.medicineName, {
      x: 1.2,
      y: 2.2,
      h: '40%',
      fontSize: 60,
      fontFace: this.brandInfoMedicine.font.title, //fontFace: 'Plus Jakarta Sans',
      color: this.brandInfoMedicine.colors.title, //color:'80eb07',
      bold: true,
      align: 'center',
    });

    const slide2 = pptx.addSlide();
    slide2.addText(this.medicineName.toUpperCase() || 'NOME FARMACO', {
      x: 0.5,
      y: 0.3,
      w: '90%',
      h: '8%',
      fontSize: 11,
      fontFace: this.brandInfoMedicine.font.title, //fontFace: 'Plus Jakarta Sans',
      color: this.brandInfoMedicine.colors.title, //color:'80eb07',
      bold: true,
      align: 'left',
    });

    /*slide3.addImage({
      path: this.brandInfoMedicine.logo.url,
      x: 8.6,
      y: 0.4,
      w: '9%',
      h: '9%'
    });*/

    slide2.addImage({
      path: this.brandInfoMedicine.logo.url,
      x: 9.2,
      y: 0.3,
      w: '4%',
      h: '6%'
    });

    //company logo
    /*slide2.addImage({
      path: this.brandInfoMedicine.logo.url,
      x: 9.2,
      y: 5,
      w: '4%',
      h: '6%'
    });*/

    slide2.addText('Informazioni Prodotto', {
      x: 0.5, // Slightly from the left edge
      y: 0.6, // Slightly from the top edge
      w: '70%', // Full slide width
      h: '8%',
      fontSize: 18,
      fontFace: this.brandInfoMedicine.font.subtitle, //fontFace: 'Plus Jakarta Sans',
      color: this.brandInfoMedicine.colors.subtitle, //color:'000000', // Aqua color
      bold: true,
      align: 'left',
    });

    slide2.addText('Dettagli e caratteristiche principali', {
      x: 0.5, // Slightly from the left edge
      y: 0.9, // Slightly from the top edge
      w: '70%', // Full slide width
      h: '8%',
      fontSize: 11,
      fontFace: this.brandInfoMedicine.font.subtitle, //fontFace: 'Plus Jakarta Sans',
      color: '000000', //color:'000000', // Aqua color
      bold: false,
      align: 'left',
    });


    //@ts-ignore
    slide2.addTable(this.medicineTableData, { x: 0.5, y: 1.5, w: '90%', valign: "middle", bold: false, fontSize: 10, color: '204131', border: { pt: '0.5', color: 'F1F1F1' } });

    //@ts-ignore
    slide2.addTable(this.medicineTherapeuticInfoTableData, { x: 0.5, y: 2.5, w: '90%', rowH: 0.5, valign: "middle", bold: false, fontSize: 10, color: '204131', border: { pt: '0.5', color: 'F1F1F1' }, });

    const slide3 = pptx.addSlide();
    slide3.addText(this.medicineName.toUpperCase() || 'NOME FARMACO', {
      x: 0.5,
      y: 0.3,
      w: '90%',
      h: '8%',
      fontSize: 11,
      fontFace: this.brandInfoMedicine.font.title, //fontFace: 'Plus Jakarta Sans',
      color: this.brandInfoMedicine.colors.title, //color:'80eb07',
      bold: true,
      align: 'left',
    });

    /*slide3.addImage({
      path: this.brandInfoMedicine.logo.url,
      x: 8.6,
      y: 0.4,
      w: '9%',
      h: '9%'
    });*/

    slide3.addImage({
      path: this.brandInfoMedicine.logo.url,
      x: 9.2,
      y: 0.3,
      w: '4%',
      h: '6%'
    });

    //company logo
    /*slide3.addImage({
      path: this.brandInfoMedicine.logo.url,
      x: 9.2,
      y: 5,
      w: '4%',
      h: '6%'
    });*/

    slide3.addText('Esperienze per Regione', {
      x: 0.5, // Slightly from the left edge
      y: 0.6, // Slightly from the top edge
      w: '70%', // Full slide width
      h: '8%',
      fontSize: 18,
      fontFace: this.brandInfoMedicine.font.subtitle, //fontFace: 'Plus Jakarta Sans',
      color: this.brandInfoMedicine.colors.subtitle, //color:'000000', // Aqua color
      bold: true,
      align: 'left',
    });

    slide3.addText('Esperienze potenziali per singola regione', {
      x: 0.5, // Slightly from the left edge
      y: 0.9, // Slightly from the top edge
      w: '70%', // Full slide width
      h: '8%',
      fontSize: 11,
      fontFace: this.brandInfoMedicine.font.subtitle, //fontFace: 'Plus Jakarta Sans',
      color: '000000', //color:'000000', // Aqua color
      bold: false,
      align: 'left',
    });

    slide3.addImage({
      data: this.experienceMapBase64String, // Base64 image from the service
      x: 0.2,
      y: 1.5,
      w: '45%',
      h: '65%'
    })

    //@ts-ignore
    slide3.addTable(this.leftExpMapTableRows, { x: 4.2, y: 1.5, colW: [1.5, 1.0], rowH: 0.3, valign: "middle", bold: false, fontSize: 8, color: '204131', border: { pt: '0.5', color: 'F1F1F1' }, });

    //@ts-ignore
    slide3.addTable(this.rightExpMapTableRows, { x: 7.0, y: 1.5, colW: [1.5, 1.0], rowH: 0.3, valign: "middle", bold: false, fontSize: 8, color: '204131', border: { pt: '0.5', color: 'F1F1F1' }, });

    const slide4 = pptx.addSlide();
    slide4.addText(this.medicineName.toUpperCase() || 'NOME FARMACO', {
      x: 0.5,
      y: 0.3,
      w: '90%',
      h: '8%',
      fontSize: 11,
      fontFace: this.brandInfoMedicine.font.title, //fontFace: 'Plus Jakarta Sans',
      color: this.brandInfoMedicine.colors.title, //color:'80eb07',
      bold: true,
      align: 'left',
    });

    /*slide3.addImage({
      path: this.brandInfoMedicine.logo.url,
      x: 8.6,
      y: 0.4,
      w: '9%',
      h: '9%'
    });*/

    slide4.addImage({
      path: this.brandInfoMedicine.logo.url,
      x: 9.2,
      y: 0.3,
      w: '4%',
      h: '6%'
    });

    //company logo
    /* slide4.addImage({
       path: this.brandInfoMedicine.logo.url,
       x: 9.2,
       y: 5,
       w: '4%',
       h: '6%'
     });*/

    slide4.addText('Heatmap Accesso Regionale', {
      x: 0.5, // Slightly from the left edge
      y: 0.6, // Slightly from the top edge
      w: '70%', // Full slide width
      h: '8%',
      fontSize: 18,
      fontFace: this.brandInfoMedicine.font.subtitle, //fontFace: 'Plus Jakarta Sans',
      color: this.brandInfoMedicine.colors.subtitle, //color:'000000', // Aqua color
      bold: true,
      align: 'left',
    });

    slide4.addText('Rappresentazione visiva dell\'accesso puro a livello Regionale, senza il dettaglio di apertura a livello Ospedaliero', {
      x: 0.5, // Slightly from the left edge
      y: 0.9, // Slightly from the top edge
      w: '90%', // Full slide width
      h: '8%',
      fontSize: 11,
      fontFace: this.brandInfoMedicine.font.subtitle, //fontFace: 'Plus Jakarta Sans',
      color: '000000', //color:'000000', // Aqua color
      bold: false,
      align: 'left',
    });

    slide4.addImage({
      data: this.regAccessMapBase64String, // Base64 image from the service
      x: 0.2,
      y: 1.5,
      w: '45%',
      h: '65%'
    });

    // Red square (Chiusura)
    slide4.addShape(pptx.ShapeType.roundRect, {
      x: 1.5,      // position on slide
      y: 5.0,
      w: 0.1,
      h: 0.1,
      fill: { color: 'C10007' },   // red
      line: { color: 'C10007' },
    });

    slide4.addText('Chiusura', {
      x: 1.5 + 0.04,      // a bit to the right of the square
      y: 5.0 + 0.04,
      fontSize: 9,
      color: '000000',
      bold: false
    });

    // Green square (Apertura)
    slide4.addShape(pptx.ShapeType.roundRect, {
      x: 2.8,
      y: 5.0,
      w: 0.1,
      h: 0.1,
      fill: { color: '008236' },   // green
      line: { color: '008236' }
    });

    slide4.addText('Apertura', {
      x: 2.8 + 0.04,
      y: 5.0 + 0.04,
      fontSize: 9,
      color: '000000',
      bold: false
    });

    slide4.addText([
      {
        text: 'Commenti:',
        options: {
          bold: true,
          color: this.brandInfoMedicine.colors.subtitle,   // green
          fontSize: 13
        }
      },
      {
        text: '\nQui puoi scrivere i tuoi commenti.',
        options: {
          italic: true,
          color: '404040',   // dark grey
          fontSize: 10
        }
      }
    ], {
      x: 4.2, // Slightly from the left edge
      y: 1.5, // Slightly from the top edge
      w: '50%', // Full slide width
      h: '50%',
      fontSize: 11,
      fontFace: this.brandInfoMedicine.font.subtitle, //fontFace: 'Plus Jakarta Sans',
      color: '000000', //color:'000000', // Aqua color
      bold: false,
      align: 'left',
      valign: 'top'
    });

    const slide5 = pptx.addSlide();
    slide5.addText(this.medicineName.toUpperCase() || 'NOME FARMACO', {
      x: 0.5,
      y: 0.3,
      w: '90%',
      h: '8%',
      fontSize: 11,
      fontFace: this.brandInfoMedicine.font.title, //fontFace: 'Plus Jakarta Sans',
      color: this.brandInfoMedicine.colors.title, //color:'80eb07',
      bold: true,
      align: 'left',
    });

    /*slide3.addImage({
      path: this.brandInfoMedicine.logo.url,
      x: 8.6,
      y: 0.4,
      w: '9%',
      h: '9%'
    });*/

    slide5.addImage({
      path: this.brandInfoMedicine.logo.url,
      x: 9.2,
      y: 0.3,
      w: '4%',
      h: '6%'
    });

    //company logo
    /*slide5.addImage({
      path: this.brandInfoMedicine.logo.url,
      x: 9.2,
      y: 5,
      w: '4%',
      h: '6%'
    });*/

    slide5.addText('Heatmap Apertura Ospedaliera', {
      x: 0.5, // Slightly from the left edge
      y: 0.6, // Slightly from the top edge
      w: '70%', // Full slide width
      h: '8%',
      fontSize: 18,
      fontFace: this.brandInfoMedicine.font.subtitle, //fontFace: 'Plus Jakarta Sans',
      color: this.brandInfoMedicine.colors.subtitle, //color:'000000', // Aqua color
      bold: true,
      align: 'left',
    });

    slide5.addText('Rappresentazione visiva dell\'apertura a livello Ospedaliero per ogni singola Regione', {
      x: 0.5, // Slightly from the left edge
      y: 0.9, // Slightly from the top edge
      w: '70%', // Full slide width
      h: '8%',
      fontSize: 11,
      fontFace: this.brandInfoMedicine.font.subtitle, //fontFace: 'Plus Jakarta Sans',
      color: '000000', //color:'000000', // Aqua color
      bold: false,
      align: 'left',
    });

    slide5.addImage({
      data: this.heatmapBase64String, // Base64 image from the service
      x: 0.2,
      y: 1.5,
      w: '45%',
      h: '65%'
    })

    slide5.addImage({
      path: './assets/img/heatmapBar.png', // Base64 image from the service
      x: 1.2,
      y: 5.0 + 0.04,
      w: '27%',
      h: '5%'
    })

    //@ts-ignore
    slide5.addTable(this.leftHeatmapTableRows, { x: 4.2, y: 1.5, colW: [1.5, 1.0], rowH: 0.3, valign: "middle", bold: false, fontSize: 8, color: '204131', border: { pt: '0.5', color: 'F1F1F1' }, });

    //@ts-ignore
    slide5.addTable(this.rightHeatmapTableRows, { x: 7.0, y: 1.5, colW: [1.5, 1.0], rowH: 0.3, valign: "middle", bold: false, fontSize: 8, color: '204131', border: { pt: '0.5', color: 'F1F1F1' }, });

    const slide6 = pptx.addSlide();
    slide6.addText(this.medicineName.toUpperCase() || 'NOME FARMACO', {
      x: 0.5,
      y: 0.3,
      w: '90%',
      h: '8%',
      fontSize: 11,
      fontFace: this.brandInfoMedicine.font.title, //fontFace: 'Plus Jakarta Sans',
      color: this.brandInfoMedicine.colors.title, //color:'80eb07',
      bold: true,
      align: 'left',
    });

    /*slide3.addImage({
      path: this.brandInfoMedicine.logo.url,
      x: 8.6,
      y: 0.4,
      w: '9%',
      h: '9%'
    });*/

    slide6.addImage({
      path: this.brandInfoMedicine.logo.url,
      x: 9.2,
      y: 0.3,
      w: '4%',
      h: '6%'
    });

    //company logo
    /*slide6.addImage({
      path: this.brandInfoMedicine.logo.url,
      x: 9.2,
      y: 5,
      w: '4%',
      h: '6%'
    });*/

    slide6.addText('Attività e Tattiche dei Piani di Accesso', {
      x: 0.5, // Slightly from the left edge
      y: 0.6, // Slightly from the top edge
      w: '70%', // Full slide width
      h: '8%',
      fontSize: 18,
      fontFace: this.brandInfoMedicine.font.subtitle, //fontFace: 'Plus Jakarta Sans',
      color: this.brandInfoMedicine.colors.subtitle, //color:'000000', // Aqua color
      bold: true,
      align: 'left',
    });

    slide6.addText('Aggregazione di livello Nazionale di tutte le attività e tattiche inserite nei piano di Accesso Regionali e Locali', {
      x: 0.5, // Slightly from the left edge
      y: 0.9, // Slightly from the top edge
      w: '90%', // Full slide width
      h: '8%',
      fontSize: 11,
      fontFace: this.brandInfoMedicine.font.subtitle, //fontFace: 'Plus Jakarta Sans',
      color: '000000', //color:'000000', // Aqua color
      bold: false,
      align: 'left',
    });

    //@ts-ignore
    slide6.addTable(this.leftActivitiesAndTacticsTableRows, { x: 0.6, y: 1.5, colW: [2.1, 0.5, 1.5], rowH: 0.2, valign: "middle", bold: false, fontSize: 8, color: '204131', border: { pt: '0.5', color: 'F1F1F1' }, });

    //@ts-ignore
    slide6.addTable(this.rightActivitiesAndTacticsTableRows, { x: 5.2, y: 1.5, colW: [2.1, 0.5, 1.5], rowH: 0.2, valign: "middle", bold: false, fontSize: 8, color: '204131', border: { pt: '0.5', color: 'F1F1F1' }, });


    const slide7 = pptx.addSlide();
    slide7.addText(this.medicineName.toUpperCase() || 'NOME FARMACO', {
      x: 0.5,
      y: 0.3,
      w: '90%',
      h: '8%',
      fontSize: 11,
      fontFace: this.brandInfoMedicine.font.title, //fontFace: 'Plus Jakarta Sans',
      color: this.brandInfoMedicine.colors.title, //color:'80eb07',
      bold: true,
      align: 'left',
    });

    /*slide3.addImage({
      path: this.brandInfoMedicine.logo.url,
      x: 8.6,
      y: 0.4,
      w: '9%',
      h: '9%'
    });*/

    slide7.addImage({
      path: this.brandInfoMedicine.logo.url,
      x: 9.2,
      y: 0.3,
      w: '4%',
      h: '6%'
    });

    //company logo
    /* slide7.addImage({
       path: this.brandInfoMedicine.logo.url,
       x: 9.2,
       y: 5,
       w: '4%',
       h: '6%'
     });*/

    slide7.addText('Evoluzione Accesso Regionale', {
      x: 0.5, // Slightly from the left edge
      y: 0.6, // Slightly from the top edge
      w: '70%', // Full slide width
      h: '8%',
      fontSize: 18,
      fontFace: this.brandInfoMedicine.font.subtitle, //fontFace: 'Plus Jakarta Sans',
      color: this.brandInfoMedicine.colors.subtitle, //color:'000000', // Aqua color
      bold: true,
      align: 'left',
    });

    slide7.addText('Accesso a livello delle singole Regioni nel corso del tempo, senza il dettaglio di apertura a livello Ospedaliero', {
      x: 0.5, // Slightly from the left edge
      y: 0.9, // Slightly from the top edge
      w: '90%', // Full slide width
      h: '8%',
      fontSize: 11,
      fontFace: this.brandInfoMedicine.font.subtitle, //fontFace: 'Plus Jakarta Sans',
      color: '000000', //color:'000000', // Aqua color
      bold: false,
      align: 'left',
    });


    //@ts-ignore
    slide7.addTable(this.regionalAccessEvolutionTableData, { x: 0.5, y: 2.0, w: '90%', valign: "middle", bold: false, fontSize: 10, color: '204131', border: { pt: '0.5', color: 'F1F1F1' } });

    const slide8 = pptx.addSlide();
    slide8.addText(this.medicineName.toUpperCase() || 'NOME FARMACO', {
      x: 0.5,
      y: 0.3,
      w: '90%',
      h: '8%',
      fontSize: 11,
      fontFace: this.brandInfoMedicine.font.title, //fontFace: 'Plus Jakarta Sans',
      color: this.brandInfoMedicine.colors.title, //color:'80eb07',
      bold: true,
      align: 'left',
    });

    /*slide3.addImage({
      path: this.brandInfoMedicine.logo.url,
      x: 8.6,
      y: 0.4,
      w: '9%',
      h: '9%'
    });*/

    slide8.addImage({
      path: this.brandInfoMedicine.logo.url,
      x: 9.2,
      y: 0.3,
      w: '4%',
      h: '6%'
    });

    //company logo
    /*slide8.addImage({
      path: this.brandInfoMedicine.logo.url,
      x: 9.2,
      y: 5,
      w: '4%',
      h: '6%'
    });*/

    slide8.addText('Curva di Accesso - Regionale', {
      x: 0.5, // Slightly from the left edge
      y: 0.6, // Slightly from the top edge
      w: '70%', // Full slide width
      h: '8%',
      fontSize: 18,
      fontFace: this.brandInfoMedicine.font.subtitle, //fontFace: 'Plus Jakarta Sans',
      color: this.brandInfoMedicine.colors.subtitle, //color:'000000', // Aqua color
      bold: true,
      align: 'left',
    });

    slide8.addText('Accesso puro a livello Regionale, ovvero inserimento in prontuario Regionale o delibera di livello Regionale o delibera dei centri prescrittori', {
      x: 0.5, // Slightly from the left edge
      y: 1.0, // Slightly from the top edge
      w: '90%', // Full slide width
      h: '8%',
      fontSize: 11,
      fontFace: this.brandInfoMedicine.font.subtitle, //fontFace: 'Plus Jakarta Sans',
      color: '000000', //color:'000000', // Aqua color
      bold: false,
      align: 'left',
    });

    slide8.addChart(pptx.ChartType.line, [
      {
        name: "Forecast",
        labels: this.openToAccessLabels,
        values: this.openToAccessTargetData,
        line: { color: "#00CEBC" }
      },
      {
        name: "Actual",
        labels: this.openToAccessLabels,
        values: this.openToAccessActualData,
        line: { color: "#141F58" }
      }
    ], {
      x: 0.5,
      y: 2.0,
      w: 4.2,
      h: 3.0,

      // --- Legend ---
      showLegend: true,
      legendPos: 'b',
      legendFontFace: this.brandInfoMedicine.font.title,
      legendFontSize: 8,

      // --- Lines & markers ---
      lineSize: 1.5,
      lineDataSymbol: 'circle',
      lineDataSymbolSize: 4,
      lineDataSymbolLineSize: 0, // no outline

      // --- Values / labels on points ---
      showValue: false,

      // --- Y axis (0–100%, step 10) ---
      valAxisMinVal: 0,
      valAxisMaxVal: 100,
      valAxisMajorUnit: 10,
      valAxisLabelFormatCode: '0"%"', // 0%, 10%, 20%, ...
      valAxisLabelFontFace: this.brandInfoMedicine.font.title,
      valAxisLabelFontSize: 8,
      valAxisLabelColor: '555555',
      valGridLine: { size: 0.5, color: 'DDDDDD', style: 'solid' },

      // --- X axis (dates, rotated) ---
      catAxisLabelFontFace: this.brandInfoMedicine.font.title,
      catAxisLabelFontSize: 8,
      catAxisLabelColor: '555555',
      catAxisLabelRotate: -45,
      catAxisLineShow: false,
      catGridLine: { size: 0, color: 'FFFFFF', style: 'solid' },

      // --- General ---
      plotArea: { fill: { color: 'FFFFFF' } },
      chartArea: { fill: { color: 'FFFFFF' }, border: { pt: 0, color: 'FFFFFF' } },
      chartColors: ["#00CEBC", "#141F58"],
      showTitle: false
    });

    //@ts-ignore
    slide8.addTable(this.openToAccessTableData, { x: 5.5, y: 1.6, colW: 1.2, rowH: 0.2, valign: "middle", bold: false, fontSize: 9, color: '204131', border: { pt: '0.5', color: 'F1F1F1' }, });

    const slide9 = pptx.addSlide();
    slide9.addText(this.medicineName.toUpperCase() || 'NOME FARMACO', {
      x: 0.5,
      y: 0.3,
      w: '90%',
      h: '8%',
      fontSize: 11,
      fontFace: this.brandInfoMedicine.font.title, //fontFace: 'Plus Jakarta Sans',
      color: this.brandInfoMedicine.colors.title, //color:'80eb07',
      bold: true,
      align: 'left',
    });

    /*slide3.addImage({
      path: this.brandInfoMedicine.logo.url,
      x: 8.6,
      y: 0.4,
      w: '9%',
      h: '9%'
    });*/

    slide9.addImage({
      path: this.brandInfoMedicine.logo.url,
      x: 9.2,
      y: 0.3,
      w: '4%',
      h: '6%'
    });

    //company logo
    /*slide9.addImage({
      path: this.brandInfoMedicine.logo.url,
      x: 9.2,
      y: 5,
      w: '4%',
      h: '6%'
    });*/

    slide9.addText('Curva di Mercato - Ospedaliero', {
      x: 0.5, // Slightly from the left edge
      y: 0.6, // Slightly from the top edge
      w: '70%', // Full slide width
      h: '8%',
      fontSize: 18,
      fontFace: this.brandInfoMedicine.font.subtitle, //fontFace: 'Plus Jakarta Sans',
      color: this.brandInfoMedicine.colors.subtitle, //color:'000000', // Aqua color
      bold: true,
      align: 'left',
    });

    slide9.addText('Apertura a livello Ospedaliero, ovvero inserimento a livello Locale con concreta e materiale apertura a livello di Centro Ospedaliero', {
      x: 0.5, // Slightly from the left edge
      y: 1.0, // Slightly from the top edge
      w: '50%', // Full slide width
      h: '8%',
      fontSize: 11,
      fontFace: this.brandInfoMedicine.font.subtitle, //fontFace: 'Plus Jakarta Sans',
      color: '000000', //color:'000000', // Aqua color
      bold: false,
      align: 'left',
    });

    slide9.addChart(pptx.ChartType.line, [
      {
        name: "Forecast",
        labels: this.openToMarketLabels,
        values: this.openToMarketTargetData,
        line: { color: "#00CEBC" }
      },
      {
        name: "Actual",
        labels: this.openToMarketLabels,
        values: this.openToMarketActualData,
        line: { color: "#141F58" }
      }
    ], {
      x: 0.5,
      y: 2.0,
      w: 4.2,
      h: 3.0,

      // --- Legend ---
      showLegend: true,
      legendPos: 'b',
      legendFontFace: this.brandInfoMedicine.font.title,
      legendFontSize: 8,

      // --- Lines & markers ---
      lineSize: 1.5,
      lineDataSymbol: 'circle',
      lineDataSymbolSize: 4,
      lineDataSymbolLineSize: 0, // no outline

      // --- Values / labels on points ---
      showValue: false,

      // --- Y axis (0–100%, step 10) ---
      valAxisMinVal: 0,
      valAxisMaxVal: 100,
      valAxisMajorUnit: 10,
      valAxisLabelFormatCode: '0"%"', // 0%, 10%, 20%, ...
      valAxisLabelFontFace: this.brandInfoMedicine.font.title,
      valAxisLabelFontSize: 8,
      valAxisLabelColor: '555555',
      valGridLine: { size: 0.5, color: 'DDDDDD', style: 'solid' },

      // --- X axis (dates, rotated) ---
      catAxisLabelFontFace: this.brandInfoMedicine.font.title,
      catAxisLabelFontSize: 8,
      catAxisLabelColor: '555555',
      catAxisLabelRotate: -45,
      catAxisLineShow: false,
      catGridLine: { size: 0, color: 'FFFFFF', style: 'solid' },

      // --- General ---
      plotArea: { fill: { color: 'FFFFFF' } },
      chartArea: { fill: { color: 'FFFFFF' }, border: { pt: 0, color: 'FFFFFF' } },
      chartColors: ["#00CEBC", "#141F58"],
      showTitle: false
    });

    //@ts-ignore
    slide9.addTable(this.openToMarketTableData, { x: 5.8, y: 0.6, colW: 1.2, rowH: 0.2, valign: "middle", bold: false, fontSize: 9, color: '204131', border: { pt: '0.5', color: 'F1F1F1' }, });


    const slide10 = pptx.addSlide();
    slide10.addText(this.medicineName.toUpperCase() || 'NOME FARMACO', {
      x: 0.5,
      y: 0.3,
      w: '90%',
      h: '8%',
      fontSize: 11,
      fontFace: this.brandInfoMedicine.font.title, //fontFace: 'Plus Jakarta Sans',
      color: this.brandInfoMedicine.colors.title, //color:'80eb07',
      bold: true,
      align: 'left',
    });

    /*slide3.addImage({
      path: this.brandInfoMedicine.logo.url,
      x: 8.6,
      y: 0.4,
      w: '9%',
      h: '9%'
    });*/

    slide10.addImage({
      path: this.brandInfoMedicine.logo.url,
      x: 9.2,
      y: 0.3,
      w: '4%',
      h: '6%'
    });

    //company logo
    /*slide10.addImage({
      path: this.brandInfoMedicine.logo.url,
      x: 9.2,
      y: 5,
      w: '4%',
      h: '6%'
    });*/

    slide10.addText('Monitoraggio di Accesso Regionale: Forecast VS Actual', {
      x: 0.5, // Slightly from the left edge
      y: 0.6, // Slightly from the top edge
      w: '70%', // Full slide width
      h: '8%',
      fontSize: 14,
      fontFace: this.brandInfoMedicine.font.subtitle, //fontFace: 'Plus Jakarta Sans',
      color: this.brandInfoMedicine.colors.subtitle, //color:'000000', // Aqua color
      bold: true,
      align: 'left',
    });

    slide10.addText('Confronto temporale, in termini di mesi, tra Forecast e Actual a livello di Accesso Regionale', {
      x: 0.5, // Slightly from the left edge
      y: 0.9, // Slightly from the top edge
      w: '90%', // Full slide width
      h: '8%',
      fontSize: 11,
      fontFace: this.brandInfoMedicine.font.subtitle, //fontFace: 'Plus Jakarta Sans',
      color: '000000', //color:'000000', // Aqua color
      bold: false,
      align: 'left',
    });

    //@ts-ignore
    slide10.addTable(this.leftMonitoringForecastvsActualTableRows, { x: 0.6, y: 1.5, colW: [1.0, 1.1, 1.1, 1.0], rowH: 0.2, valign: "middle", bold: false, fontSize: 8, color: '204131', border: { pt: '0.5', color: 'F1F1F1' }, });

    //@ts-ignore
    slide10.addTable(this.rightMonitoringForecastvsActualTableRows, { x: 5.2, y: 1.5, colW: [1.0, 1.1, 1.1, 1.0], rowH: 0.2, valign: "middle", bold: false, fontSize: 8, color: '204131', border: { pt: '0.5', color: 'F1F1F1' }, });

    const slide11 = pptx.addSlide();
    slide11.addText(this.medicineName.toUpperCase() || 'NOME FARMACO', {
      x: 0.5,
      y: 0.3,
      w: '90%',
      h: '8%',
      fontSize: 11,
      fontFace: this.brandInfoMedicine.font.title, //fontFace: 'Plus Jakarta Sans',
      color: this.brandInfoMedicine.colors.title, //color:'80eb07',
      bold: true,
      align: 'left',
    });

    /*slide3.addImage({
      path: this.brandInfoMedicine.logo.url,
      x: 8.6,
      y: 0.4,
      w: '9%',
      h: '9%'
    });*/

    slide11.addImage({
      path: this.brandInfoMedicine.logo.url,
      x: 9.2,
      y: 0.3,
      w: '4%',
      h: '6%'
    });

    //company logo
    /*slide11.addImage({
      path: this.brandInfoMedicine.logo.url,
      x: 9.2,
      y: 5,
      w: '4%',
      h: '6%'
    });*/

    slide11.addText('Accesso Regionale: Dove siamo ad oggi', {
      x: 0.5, // Slightly from the left edge
      y: 0.6, // Slightly from the top edge
      w: '70%', // Full slide width
      h: '8%',
      fontSize: 18,
      fontFace: this.brandInfoMedicine.font.subtitle, //fontFace: 'Plus Jakarta Sans',
      color: this.brandInfoMedicine.colors.subtitle, //color:'000000', // Aqua color
      bold: true,
      align: 'left',
    });

    slide11.addText('Progresso temporale, con una comparazione in giorni tra la data di Forecast in Accesso Regionale e la data odierna', {
      x: 0.5, // Slightly from the left edge
      y: 0.9, // Slightly from the top edge
      w: '90%', // Full slide width
      h: '8%',
      fontSize: 11,
      fontFace: this.brandInfoMedicine.font.subtitle, //fontFace: 'Plus Jakarta Sans',
      color: '000000', //color:'000000', // Aqua color
      bold: false,
      align: 'left',
    });

    //@ts-ignore
    slide11.addTable(this.leftRegionalAccessTableRows, { x: 0.6, y: 1.5, colW: 1.5, rowH: 0.2, valign: "middle", bold: false, fontSize: 8, color: '204131', border: { pt: '0.5', color: 'F1F1F1' }, });

    //@ts-ignore
    slide11.addTable(this.rightRegionalAccessTableRows, { x: 5.2, y: 1.5, colW: 1.5, rowH: 0.2, valign: "middle", bold: false, fontSize: 8, color: '204131', border: { pt: '0.5', color: 'F1F1F1' }, });



    // Save the presentation
    pptx.writeFile({ fileName: 'Report-Nazionale' });
    this.processMessage = '';
    this.onClose();
    await new Promise((resolve) => setTimeout(resolve, 1000));
  }

  onClose (): void {
    this.isModalOpen.emit(false); // Emit cancel event
  }

  //Load Complete Italy Map
  async loadExperienceMap (): Promise<void> {

    await new Promise(resolve => setTimeout(resolve, 1000));



    if (this.experienceMapData && this.experienceMapData.length > 0) {
      //  console.log('data', data);

      const regioniData = this.experienceMapData.map(item => {
        if (item.percentage !== undefined) {
          item.percentage = parseFloat(item.percentage).toFixed(2);
        }

        /*if (Number(item.regionId) === 4) {
          // Find additional data for id5 and combine the tooltip text
          const region5 = data.find(i => Number(i.regionId) === 5);
          if (region5) {
            return {
              ...item,
              tooltipText: `${item.regionName}: ${item.percentage}%<br>${region5.regionName}: ${region5.percentage}%`
            };
          }
        }*/
        // Default tooltip text for other regions
        return {
          ...item,
          tooltipText: `${item.regionName}: <br>${item.percentage}%`
        };
      });


      this.layersExpMap = [
        {
          shapeData: italyMap,
          shapePropertyPath: 'id',
          shapeDataPath: 'regionId',
          dataSource: regioniData,
          tooltipSettings: {
            visible: true,
            valuePath: 'tooltipText',
            //format: '${regionName}: <br>${percentage}%'
          },
          highlightSettings: {
            enable: false,
          },
          selectionSettings: {
            enable: false,
            fill: '#FFFFFF',
            border: {
              color: '#162456',
              width: 1,
            },
            opacity: 1,
          },

          shapeSettings: {
            //fill: '#088a95',
            //fill: '#088091',

            fill: '#FFFFFF',
            colorValuePath: '#DDE1E5',
            border: {
              color: '#162456',
              width: 0.7,
            },
          },
        },
      ];
    }
    await new Promise((resolve) => setTimeout(resolve, 1000));
    console.log("[DEBUG] HeatMap data received:",);
  }


  onExperienceMapLoaded (): void {
    if (!this.experienceMap) {
      console.error('Map component reference is null or undefined.');
      return;
    }

    const promise = (this.experienceMap as MapsComponent).export('PNG', 'Maps', undefined, false);

    if (!promise) {
      console.error('Export method did not return a promise.');
      return;
    }

    promise
      .then((data: any) => {
        this.experienceMapBase64String = data;
      })
      .catch((error: any) => {
        console.error('Error exporting the map:', error);
      });
  }

  //Load Complete Italy Map
  async loadRegAccessMap (): Promise<void> {

    await new Promise(resolve => setTimeout(resolve, 1000));

    const regioniHeatmapData = this.regionalAccessMapData.map(item => {
      let statusText = '';

      if (item.isCompleted === true) {
        statusText = 'Apertura';
      } else {
        statusText = 'Chiusura';
      }

      return {
        regionId: item.regionId,
        regionName: item.regionName,
        isCompleted: item.isCompleted,
        tooltipText: `${item.regionName}: <br> ${statusText}`
      };
    });

    this.layersRegAccessMap = [
      {
        shapeData: italyMap,
        shapePropertyPath: 'id',
        shapeDataPath: 'regionId',
        dataSource: regioniHeatmapData,
        tooltipSettings: {
          visible: true,
          valuePath: 'tooltipText',
        },
        highlightSettings: {
          enable: false,
          fill: '#00CEBC'
        },
        selectionSettings: {
          enable: false,
          fill: '',
          opacity: 1,
        },
        shapeSettings: {
          border: {
            color: '#FFFFFF',
            width: 0.4,
          },
          colorValuePath: 'isCompleted',
          colorMapping: [
            {
              value: true,
              color: '#008236'
            },
            {
              value: false,
              color: '#C10007'
            }
          ]
        }
      }
    ];

    await new Promise((resolve) => setTimeout(resolve, 1000));
    console.log("[DEBUG] HeatMap data received:",);
  }

  onRegAccessMapLoaded (): void {
    if (!this.regAccessMap) {
      console.error('Map component reference is null or undefined.');
      return;
    }

    const promise = (this.regAccessMap as MapsComponent).export('PNG', 'Maps', undefined, false);

    if (!promise) {
      console.error('Export method did not return a promise.');
      return;
    }

    promise
      .then((data: any) => {
        this.regAccessMapBase64String = data;
      })
      .catch((error: any) => {
        console.error('Error exporting the map:', error);
      });
  }
  async loadHeatmap (): Promise<void> {

    await new Promise(resolve => setTimeout(resolve, 1000));

    if (this.heatmapData && this.heatmapData.length > 0) {
      const regioniHeatmapData = this.heatmapData.map(item => {
        // Parse percentage and default to 0 if undefined
        const percentage = item.percentage !== undefined ? parseFloat(item.percentage).toFixed(2) : 0;

        // Default logic for other regions
        return {
          ...item,
          tooltipText: `${item.regionName}: <br> ${percentage}%`,
          percentage, // Use percentage for default colorMapping
          color: '' // Leave blank for colorMapping regions
        };
      });

      this.layersHeatmap = [
        {
          shapeData: italyMap,
          shapePropertyPath: 'id',
          shapeDataPath: 'regionId',
          dataSource: regioniHeatmapData,
          tooltipSettings: {
            visible: true,
            valuePath: 'tooltipText'
          },
          highlightSettings: {
            enable: false,
            fill: '#00CEBC'
          },
          selectionSettings: {
            enable: true,
            fill: '',
            opacity: 1,
          },
          shapeSettings: {
            borderWidth: 4,
            colorValuePath: 'percentage', // Default regions use this
            fill: (properties: any) => {
              const regionData = regioniHeatmapData.find(
                (region: any) => region.regionId === properties.id
              );
              return regionData && regionData.color ? regionData.color : null; // Use dynamic color for regions 4 and 5
            },
            colorMapping: [
  { from: 0, to: 0, color: '#c10007' },

  { from: 0.01, to: 8.33, color: '#dd3a3f' },
  { from: 8.34, to: 16.66, color: '#e95b43' },
  { from: 16.67, to: 24.99, color: '#f47938' },
  { from: 25.00, to: 33.32, color: '#fba63a' },
  { from: 33.33, to: 41.65, color: '#ffd04c' },
  { from: 41.66, to: 49.98, color: '#ffe84a' },
  { from: 49.99, to: 58.31, color: '#e4f042' },
  { from: 58.32, to: 66.64, color: '#c5e73c' },
  { from: 66.65, to: 74.97, color: '#9fdd38' },
  { from: 74.98, to: 83.30, color: '#7cca33' },
  { from: 83.31, to: 91.63, color: '#51b42f' },
  { from: 91.64, to: 99.99, color: '#2e9c2b' },

  { from: 100, to: 100, color: '#008236' }
]
          }
        }
      ];
    }

    await new Promise((resolve) => setTimeout(resolve, 1000));
    console.log("[DEBUG] HeatMap data received:",);
  }

  onHeatMapLoaded (): void {
    if (!this.heatmap) {
      console.error('Map component reference is null or undefined.');
      return;
    }

    const promise = (this.heatmap as MapsComponent).export('PNG', 'Maps', undefined, false);

    if (!promise) {
      console.error('Export method did not return a promise.');
      return;
    }

    promise
      .then((data: any) => {
        this.heatmapBase64String = data;
      })
      .catch((error: any) => {
        console.error('Error exporting the map:', error);
      });
  }


  // Helper to format date point "YYYY-MM" to "Month-YY"
  private formatDatePointToIt (datePoint: string): string {
    const [year, month] = datePoint.split('-');
    const idx = Number(month) - 1;
    return `${this.monthNamesIt[idx]}-${year.slice(-2)}`; // "Nov-25"
  }

  // Helper to build cumulative series for Open to Access/Market chart
  private buildCumulativeSeries (
    labels: string[],
    points: { month: string; value: number }[]
  ): (number | null)[] {
    /*let cumulative = 0;
    return labels.map(labelMonth => {
      const point = points.find(p => p.month === labelMonth);
      if (point) {
        cumulative += point.value;
      }
      return Number(cumulative.toFixed(2));
    });*/
    // Map label -> index
    const labelToIndex = new Map<string, number>();
    labels.forEach((m, idx) => labelToIndex.set(m, idx));

    // Find indices where we do have data
    const indicesWithPoint = points
      .map(p => labelToIndex.get(p.month))
      .filter((idx): idx is number => idx !== undefined)
      .sort((a, b) => a - b);

    if (!indicesWithPoint.length) {
      // no data at all
      return labels.map(() => null);
    }

    const firstIdx = indicesWithPoint[0];
    const lastIdx = indicesWithPoint[indicesWithPoint.length - 1];

    let cumulative = 0;
    const result: (number | null)[] = new Array(labels.length).fill(null);

    for (let i = 0; i < labels.length; i++) {
      // before first or after last → no line
      if (i < firstIdx || i > lastIdx) {
        result[i] = null;
        continue;
      }

      const month = labels[i];
      const point = points.find(p => p.month === month);
      if (point) {
        cumulative += point.value;
      }

      result[i] = Number(cumulative.toFixed(2));
    }

    return result;
  }

  private normalizeDateString (due: string): string {
    if (!due) return '';
    return due.replace(/[^0-9]/g, '');
  }


  formatDate (due: string): string {
    const cleanDue = this.normalizeDateString(due);
    if (cleanDue.length !== 8) return 'No Data';

    const year = cleanDue.substring(0, 4);
    const month = cleanDue.substring(4, 6);
    const day = cleanDue.substring(6, 8);

    return `${day}/${month}/${year}`;
  }

  compareDates (due: string): number {
    const cleanDue = this.normalizeDateString(due);
    if (cleanDue.length !== 8) return 0;

    const year = parseInt(cleanDue.substring(0, 4), 10);
    const month = parseInt(cleanDue.substring(4, 6), 10) - 1;
    const day = parseInt(cleanDue.substring(6, 8), 10);

    const dueDate = new Date(year, month, day);
    dueDate.setHours(0, 0, 0, 0);

    const delta = Math.round((this.today.getTime() - dueDate.getTime()) / (1000 * 60 * 60 * 24));
    return delta;
  }

}
